import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err:any)=>{
        const error=err?.message;
        if([410,403].indexOf(err.status)!==-1){
          return throwError(()=>new Error(error?error:"Your session has expired"));
        }
        return throwError(()=>new Error(error));
      })
    );
  }
}
